import { DocumentSupportDetailPrintModel } from "./document-support-detail-print.model";

export class DocumentSupportPrintModel {
    documentSupportId: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    branchCode: number = 0;
    branchName: string = '';
    enterpriseId: number = 0;
    enterpriseNit: string = '';
    enterpriseName: string = '';
    bussinessDocumentsTypeId: number = 0;
    bussinessDocumentsDianTypeId: number = 0;
    departmentCityBranch: string = '';
    addressBranch: string = '';
    phoneBranch: string = '';
    prefix: string = '';
    validity: number = 0;
    numberResolution: string = '';
    dateResolution: Date = new Date();
    initialDocument: string = '';
    finalDocument: string = '';
    providerNitName: string = '';
    providerAddress: string = '';
    providerPhone: string = '';
    tecnologyProvider: string = '';
    consecutive: string = '';
    dateDocument: Date = new Date();
    totalValue: number = 0;
    observation: string = '';
    cuds: string = '';
    qrData: string = '';
    dateValidationDian: Date | null = null;
    xmlName: string = '';
    documentSupportDetails: DocumentSupportDetailPrintModel[] = [];

}